var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTransprency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7944 4.82495L12.567 22.4681C12.3704 22.777 12.3583 23.1687 12.5356 23.4891L22.9697 42.3507",
    stroke: "#03F5AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5464 4.82495L4.31891 22.4681C4.12234 22.777 4.1103 23.1687 4.28754 23.4891L14.7216 42.3507",
    stroke: "#03F5AE",
    strokeDasharray: "2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3962 22.8722L31.2041 5.356C31.5913 4.72847 32.5013 4.72153 32.8981 5.34307L44.0789 22.8597C44.283 23.1794 44.2886 23.587 44.0935 23.9122L32.9129 42.5465C32.5211 43.1995 31.5724 43.1924 31.1904 42.5337L20.3822 23.899C20.1974 23.5803 20.2028 23.1858 20.3962 22.8722Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransprency);
export default __webpack_public_path__ + "static/media/ic_transprency.d8e6d4dd6e8731fa5ecfd0b9d79d600a.svg";
export { ForwardRef as ReactComponent };